import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots } from "vue"

const _hoisted_1 = {
  key: 1,
  width: "28",
  height: "22",
  viewBox: "0 0 28 22",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  style: {"width":"1.7em","margin-top":"-3px"},
  class: "d-inline-block"
}

import OperatorApplicationDialogTextareaButton
    from "~/operatorApplication/vue/dialogs/dialog/OperatorApplicationDialogTextareaButton.vue";
import FontAwesomeIcon from "~/cabinet/vue/interface/icon/FontAwesomeIcon.vue";
import {computed, ref} from "vue";
import {CopilotCommandRunner} from "~/operatorApplication/ts/service/copilot/CopilotCommandRunner";
import useTextareaComponent from "~/operatorApplication/vue/dialogs/dialog/textarea/useTextareaComponent";
import {TRANSLATE_COMMAND_ID} from "~/operatorApplication/ts/service/copilot/constants";
import getTranslateCommandParams from "~/operatorApplication/ts/service/copilot/getTranslateCommandParams";
import {__} from "~/ts/library/Translate";
import {toggleCopilotSuggests} from "~/operatorApplication/ts/service/copilot/toggleCopilotSuggests";
import getCopilotsBySite from "~/operatorApplication/ts/service/copilot/getCopilotsBySite";

import MoreFriendlyCommandParamsOpenApiModel = OperatorApplicationApi.MoreFriendlyCommandParamsOpenApiModel;

import {defineComponent} from 'vue';

const __default__ = defineComponent({
    name: "CopilotCommandButton"
});

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

let {
    site,
    client,
    model,
    showCopilotTimeoutError,
    toggleCopilotRunning,
    isCopilotRunning,
    resetTextareaSelection
} = useTextareaComponent();

const TOGGLE_SUGGESTS_COMMAND = "toggleSuggests";

let runningCopilotCommands = ref(0);

let textCopilotCommands = computed(() => site.value?.copilotCommands
    .filter(command => command.isTextCommand || (command.id == TRANSLATE_COMMAND_ID && client.value.languageIsoCode)) ?? []
);

let text = computed(() => {
    let text = (model.value.text ?? "").trim();
    return text.length > 0 ? text : null;
});

let hasText = computed(() => typeof text.value == "string");

let valueBeforeCommand = ref<string>();

const UNDO_COMMAND = "undo";

async function runCopilotCommand(command: OperatorApplicationApi.OperatorApplicationCopilotCommandTypeOpenApiModel | typeof UNDO_COMMAND | typeof TOGGLE_SUGGESTS_COMMAND) {
    if (command === TOGGLE_SUGGESTS_COMMAND) {
        return toggleCopilotSuggests(client.value, !client.value.copilot.enabled);
    }
    if (command === UNDO_COMMAND) {
        return undo();
    }
    if (hasText.value && command && command.id) {
        let p: OperatorApplicationApi.OperatorCopilotCommandOpenApiModel = {
            type: command.id as any
        };
        if (command.isTextCommand) {
            p.params = {
                text: model.value.text
            } as MoreFriendlyCommandParamsOpenApiModel
        } else if (command.id == TRANSLATE_COMMAND_ID) {
            p.params = getTranslateCommandParams(client.value, model.value.text);
        }
        if (p.params) {
            changeCommandCount(1);
            let result = await CopilotCommandRunner.exec({
                username: client.value.username,
                command: p,
                onResult: response => {
                    valueBeforeCommand.value = model.value.text;
                    model.value.text = response;
                    changeCommandCount(-1);
                },
                onTimeout: () => {
                    changeCommandCount(-1);
                    if (runningCopilotCommands.value == 0) {
                        showCopilotTimeoutError();
                    }
                }
            });
            if (result.showMessageOnError()) {
                changeCommandCount(-1);
            }
        }
    }
}

function changeCommandCount(value: number) {
    runningCopilotCommands.value += value;
    toggleCopilotRunning(runningCopilotCommands.value > 0);
}

function onDropdownOpen() {
    resetTextareaSelection();
}

let disabled = ref(false);

function undo() {
    model.value.text = valueBeforeCommand.value;
    valueBeforeCommand.value = null;
    document.body.dispatchEvent(new MouseEvent("click"));
}


return (_ctx: any,_cache: any) => {
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!

  return (_openBlock(), _createBlock(OperatorApplicationDialogTextareaButton, {
    tooltip: "AI Copilot",
    icon: "sparkles",
    "hide-on-click": "",
    "dropdown-placement": "top-start",
    style: {"margin-right":".6em"},
    disabled: _unref(disabled),
    onCommand: _cache[0] || (_cache[0] = ($event: any) => (runCopilotCommand($event as any))),
    onClick: onDropdownOpen
  }, _createSlots({
    icon: _withCtx(({inDropdownMenu}) => [
      _createElementVNode("span", {
        class: _normalizeClass(!inDropdownMenu ? 'mr-1' : ''),
        style: _normalizeStyle((inDropdownMenu ? 'margin-left: -.35em;' : '') + ' margin-top:-1px;')
      }, [
        (_unref(isCopilotRunning))
          ? (_openBlock(), _createBlock(FontAwesomeIcon, {
              key: 0,
              icon: "circle-notch",
              solid: "",
              class: "fa-spin",
              style: {"color":"#665bd8 !important","width":"1.7em"}
            }))
          : (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[1] || (_cache[1] = [
              _createElementVNode("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M4 0C1.79089 0 0 1.79086 0 4V18C0 20.2091 1.79089 22 4 22H24C26.2091 22 28 20.2091 28 18V4C28 1.79086 26.2091 0 24 0H4ZM13.2891 13.3145L14.1299 15.8643H15.9893L12.4893 6H10.5L7 15.8643H8.81836L9.65918 13.3145H13.2891ZM10.0693 11.9541L11.4502 7.74316H11.498L12.8721 11.9541H10.0693ZM17.0488 15.8643H18.8125V6H17.0488V15.8643Z",
                fill: "#665bd8"
              }, null, -1)
            ]))]))
      ], 6)
    ]),
    _: 2
  }, [
    (!_unref(isCopilotRunning))
      ? {
          name: "dropdown",
          fn: _withCtx(() => [
            _createVNode(_component_el_dropdown_menu, { class: "overflow-hidden" }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(textCopilotCommands), (command) => {
                  return (_openBlock(), _createBlock(_component_el_dropdown_item, {
                    key: command.id,
                    command: command,
                    disabled: !_unref(hasText)
                  }, {
                    default: _withCtx(() => [
                      _createVNode(FontAwesomeIcon, {
                        icon: command.icon,
                        class: "mr-2"
                      }, null, 8, ["icon"]),
                      _createTextVNode(" " + _toDisplayString(command.descr), 1)
                    ]),
                    _: 2
                  }, 1032, ["command", "disabled"]))
                }), 128)),
                (_unref(valueBeforeCommand))
                  ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                      key: 0,
                      command: UNDO_COMMAND
                    }, {
                      default: _withCtx(() => [
                        _createVNode(FontAwesomeIcon, {
                          icon: "undo",
                          class: "mr-2"
                        }),
                        _createTextVNode(" " + _toDisplayString(_unref(__)("Отменить последнее действие")), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_unref(getCopilotsBySite)(_unref(site)).length > 0)
                  ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                      key: 1,
                      command: TOGGLE_SUGGESTS_COMMAND
                    }, {
                      default: _withCtx(() => [
                        _createVNode(FontAwesomeIcon, {
                          icon: "sparkles",
                          class: "mr-2"
                        }),
                        (_unref(client).copilot.enabled)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(_toDisplayString(_unref(__)("Выключить подсказки")), 1)
                            ], 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createTextVNode(_toDisplayString(_unref(__)("Включить подсказки")), 1)
                            ], 64))
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          key: "0"
        }
      : undefined
  ]), 1032, ["disabled"]))
}
}

})